import { Component, OnInit } from '@angular/core';
import { EnumAPIStatus } from '@api/AbstractAPI';
import { ModalController, NavParams } from '@ionic/angular';
import { EnumGenericRoleActionAlerts } from '@pages/BasePage';

@Component({
    selector: 'app-select-representative-profile',
    templateUrl: './select-representative-profile.component.html',
    styleUrls: ['./select-representative-profile.component.scss'],
})
export class SelectRepresentativeProfileComponent implements OnInit {

    public Data: any[] = [];

    private onSave: Function;

    private onGetUsers: Function;

    constructor(
        private NavParams: NavParams,
        private ModalController: ModalController
    ) {

        this.onSave = this.NavParams?.get('onSave') || null;

        this.Data = this.NavParams?.get('data') || [];


    }

    async ngOnInit() {

        // if (this.onGetUsers)
        // 	this.Data = await this.onGetUsers();

    }



    public async OnSaveAssociation(ev: any, item) {

        ev?.preventDefault();
        ev?.stopPropagation();

        this.ModalController.dismiss(item, EnumGenericRoleActionAlerts.Confirm);



    }

    Close() {
        // using the injected ModalController this page
        // can "dismiss" itself and optionally pass back data
        this.ModalController.dismiss(null, EnumGenericRoleActionAlerts.Close);
    }

}

